import { Card } from "@fpsoftware/mvp";
import { formatMoney, formatPercent, type PrepaidItemDTO } from "shared";
import { formatPeriod } from "@/time/duration";

export function PrepaidListItem(props: { item: PrepaidItemDTO }) {
  const { item } = props;

  switch (item.type) {
    case "PrepaidInterest":
      return (
        <Card.ListItem label="Prepaid Interest">
          <div>{formatMoney(item.amount)}</div>
          <small>{formatPeriod(item.period)}</small>
        </Card.ListItem>
      );
    case "SellerCredit":
      return (
        <Card.ListItem label="Seller Credit">
          {formatMoney(item.amount)}
        </Card.ListItem>
      );
    case "FlatFee":
      return (
        <Card.ListItem label={item.label}>
          {formatMoney(item.amount)}
        </Card.ListItem>
      );
    case "PropertyTax":
      return (
        <Card.ListItem label="Property tax">
          <div>{formatMoney(item.amount)}</div>
          <small>{formatPeriod(item.period)}</small>
        </Card.ListItem>
      );
    case "PropertyInsurance":
      return (
        <Card.ListItem label="Property insurance">
          <div>{formatMoney(item.amount)}</div>
          <small>{formatPeriod(item.period)}</small>
        </Card.ListItem>
      );
    case "MortgageInsurance":
      return (
        <Card.ListItem label="Mortgage insurance">
          <div>{formatMoney(item.amount)}</div>
          <small>{formatPeriod(item.period)}</small>
        </Card.ListItem>
      );
    case "HoaFee":
      return (
        <Card.ListItem label="HOA payment">
          <div>{formatMoney(item.amount)}</div>
          <small>{formatPeriod(item.period)}</small>
        </Card.ListItem>
      );
    case "DiscountPoints":
      return (
        <Card.ListItem label="Discount points">
          <div>{formatMoney(item.amount)}</div>
          <small>{formatPercent(item.percentage.afterCompensation)}</small>
        </Card.ListItem>
      );
    default:
      return (
        <Card.ListItem label="Unknown Prepaid Item">
          {formatMoney(item.amount)}
        </Card.ListItem>
      );
  }
}
